import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DeliveryOrderService } from 'app/services';
import { ServiceTypeEnum } from 'app/models';
import { Utils } from 'app/utils';

interface NearbyRiderForAssign
{
    Id: number;
    FirstName: string;
    LastName: string;
    ImageUrl: string;
    DistanceInKm: number;
}

@Component({
    selector: 'live-map-assign-rider',
    templateUrl: './live-map-assign-rider.component.html',
    styleUrls: ['./live-map-assign-rider.component.scss']
})
export class LiveMapAssignRiderComponent implements OnInit {
    @Input()
    public orderFromList: any = {};

    @Input()
    public mapBounds: {
        NorthWestPoint: { lat: number; long: number };
        SouthEastPoint: { lat: number; long: number };
    } = {
            NorthWestPoint: { lat: 0, long: 0 },
            SouthEastPoint: { lat: 0, long: 0 }
        };

    @Output()
    public assignRider: EventEmitter<void> = new EventEmitter<void>();

    @Output()
    public hide: EventEmitter<void> = new EventEmitter<void>();

    public visible: boolean = true;

    public riders: NearbyRiderForAssign[] = [];

    public isSpinnerVisible: boolean = true;

    constructor(
        private messageService: MessageService,
        private deliveryOrderService: DeliveryOrderService) {
    }

    ngOnInit(): void {
		this.getOrder();
    }

    private getOrder(): void {
        const dto: any = {
            OrderId: this.orderFromList.Id
        };

        if (!dto.OrderId) {
            dto.OrderId = this.orderFromList.XpressDeliveryOrderId;
        }

        this.deliveryOrderService.getNearbyDriversForAssign(dto, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.riders = data.Riders;

                this.isSpinnerVisible = false;
            });
    }

    public onAssignRider(riderId: number): void {
        const dto = {
            OrderId: this.orderFromList.Id,
            RiderId: riderId,
			TimeZoneOffset: Utils.getTimezoneOffset()
        };

        const service = this.orderFromList.ScheduledAt === null ? 'offerOrderToRider' : 'assignScheduledOrderToRider';
        this.deliveryOrderService[service](dto, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

				if (!data.Success) {
					if (this.orderFromList.ServiceTypeId === ServiceTypeEnum.DayTrip) {
						this.messageService.add({
							severity: 'error',
							summary: 'Driver Not Eligible',
							detail: 'This driver cannot be assigned to the Day Trip. Please choose another driver. ' + data.ErrorMessage
						});
					} else {
						this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
					}
                    return;
                }

                this.assignRider.emit();
            });
    }

    public onDialogHide(): void {
        this.hide.emit();
    }
}
